import { render } from "./ListAnhChup.vue?vue&type=template&id=531cdb47&scoped=true"
import script from "./ListAnhChup.vue?vue&type=script&lang=js"
export * from "./ListAnhChup.vue?vue&type=script&lang=js"

import "./ListAnhChup.vue?vue&type=style&index=0&id=531cdb47&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531cdb47"]])

export default __exports__